import type { SerializedJob } from '@enmon/commons/lib/tools';
import { gql } from '@apollo/client';

export const GET_ASYNC_JOBS_LIST_DATA = gql`
  query getAsyncJobsListData($filter: JobFiltersInput, $limit: Int, $sort: [String], $start: Int) {
    jobs(filters: $filter, pagination: { limit: $limit, start: $start }, sort: $sort) {
      # table columns
      data {
        id
        attributes {
          name
          status
          createdAt
          data
          fail_reason
        }
      }
      meta {
        pagination {
          total
        }
      }
    }
  }
`;

export interface AsyncJobsCardVariables {
  limit: number;
  sort?: string[];
  start: number;
}

export type AsyncJobData = Pick<SerializedJob, 'id' | 'name' | 'status' | 'createdAt' | 'fail_reason' | 'data'>;

export interface AsyncJobListData {
  jobs: {
    data: AsyncJobData[];
    meta: { pagination: { total: number } };
  };
}
